import { Box, Grid } from '@material-ui/core'
import { ChevronRight } from '@material-ui/icons'
import { AsterChip } from 'asterX-UI/Chip'
import { getStatusColor, getStatusLabel } from 'lib/constants/deals'
import { getDaysLabel, getFomattedDateWithTime } from 'lib/utils'
import React from 'react'

export const homeManagerColumns = homeStoreFunc => {
  return [
    '№',
    'Тип просрочки',
    'Клиент',
    'LEVEL',
    'Филиал shinhan',
    'Продукт',
    <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc.handleSort('loanAmount')}>
      Сумма займа {homeStoreFunc.getArrow('loanAmount')}
    </Box>,
    <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc?.handleSort('overdueTranchesSum')}>
      Сумма просрочки {homeStoreFunc?.getArrow('overdueTranchesSum')}
    </Box>,
    <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc.handleSort('overdueDays')}>
      Дни просрочки {homeStoreFunc.getArrow('overdueDays')}
    </Box>,
    'Статус',
    'Последнее действие',
    'У менеджера',
    ''
  ]
}

export const homeManagerRows = list => {
  if (!list) {
    return []
  }

  return list?.map(item => {
    return [
      item?.contractNumber,
      <AsterChip label={item?.overdueType} />,
      item?.clientFullName?.replace('null', '').trim() || '-',
      <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{item?.level || '-'}</Grid>,
      item?.subdivisionName,
      item?.creditProductName,
      item?.loanAmount?.toString()?.thousandSeparator(),
      item?.overdueTranchesSum?.toString()?.thousandSeparator(),
      <Grid item>{`${item?.overdueDays || 0} ${getDaysLabel(item?.overdueDays)}`}</Grid>,
      <AsterChip
        label={item?.statusName || getStatusLabel(item?.workListStatusCode) || 'Новый'}
        style={{ ...getStatusColor(item?.statusCode || item?.workListStatusCode || 'Новый'), maxWidth: 100 }}
      />,
      <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} item>
        {item?.lastManagerEventAt ? getFomattedDateWithTime(item?.lastManagerEventAt) : '-'}
      </Grid>,
      <Grid item>{`${item?.lastAssignChangeDays} ${getDaysLabel(item?.lastAssignChangeDays)}`}</Grid>,
      {
        isButton: true,
        label: <ChevronRight />,
        data: { id: item?.id }
      }
    ]
  })
}
